import { styled } from 'styled-components';

const Button = styled.button`
  padding: 10px 20px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #cbd5e0;
    cursor: not-allowed;
  }
`;

export const ButtonCommit = styled(Button)`
  padding: 8px 16px;
  background-color: #10b981;
  color: white;

  &:hover:not(:disabled) {
    background-color: #059669;
  }
`;

export const ButtonClear = styled(Button)`
  padding: 8px 16px;
  background-color: #ef4444;
  color: white;

  &:hover:not(:disabled) {
    background-color: #dc2626;
  }
`;

export const ButtonReset = styled(Button)`
  background-color: #ef4444;
  color: white;

  &:hover:not(:disabled) {
    background-color: #dc2626;
  }
`;

export const ButtonLoad = styled(Button)`
  background-color: #4299e1;
  color: white;

  &:hover:not(:disabled) {
    background-color: #3182ce;
  }
`;

export const ButtonSync = styled(Button)`
  background-color: #10b981;
  color: white;

  &:hover:not(:disabled) {
    background-color: #059669;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;
